module.exports = __webpack_public_path__ + "static/media/Team-invoice-pic-5.9833b16b.png";